export default __webpack_public_path__ + "static/media/carlo-ventura.ac426f64.png";